import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["event", "branchOverrideValue", "setBranchOverrideValue", "flow"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import BranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchOverrideView';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const UnpredictableBranchOverrideView = _ref => {
  let {
      event,
      branchOverrideValue,
      setBranchOverrideValue,
      flow
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(rest);
  return /*#__PURE__*/_jsx(BranchOverrideView, Object.assign({}, tokenProps, {
    alertProps: {
      titleText: branchOverrideValue === undefined && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformTest.badges.branch.unpredictable.overrideTitle"
      }),
      type: branchOverrideValue === undefined ? 'warning' : 'info'
    },
    descriptionText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformTest.badges.branch.unpredictable.overrideDescription"
    }),
    flow: flow,
    event: event,
    branchOverrideValue: branchOverrideValue,
    setBranchOverrideValue: setBranchOverrideValue,
    shouldShowFollowedBranchByDefault: false
  }));
};
export default UnpredictableBranchOverrideView;